import React from "react";
import SubTitle from "../../components/common/SubTitle";
import AnalyticsChart from "../../components/manageData/Analytics/AnalyticsChart";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import { Box } from "@mui/material";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";

export default function AnalyticsPage() {
  const organization = localStorage.getItem("userState") || "Organization";
  const orgName = JSON.parse(organization).organization.name;
  const app = localStorage.getItem("selectedApp") || "App";
  return (
    <>
      <TitleBar />
      {app !== "schoolTrack" ? <NavMenu /> : <SchoolBusNavMenu />}
      <SubTitle
        title="Analytics"
        path={
          app !== "schoolTrack" ? `${orgName} > Reports > Analytics` : undefined
        }
      />
      <Box
        sx={{
          mx: "40px",
          border: "1px solid #C8CBD0",
          borderRadius: "16px",
          p: 2,
        }}
      >
        <AnalyticsChart />
      </Box>
      <Footer />
    </>
  );
}
